import React from "react";
import { RecentSearchesClear, RecentSearchesHeader, RecentSearchesItem, RecentSearchesItemClear, RecentSearchesList, RecentSearchesTitle, SearchButton, SearchContainer, SearchIcon, SearchInput, SearchResult, SearchResultItem, SearchResultList } from "./styles";
import { AssetImageUrl } from "../../../../assets/imgUrl";
import { getKeywordsAutocomplete } from "../../../../services/header/header";
import { lsGetItem, lsSetItem } from "../../../../utils/safeWebStorage";
import langGroup from "../../../../assets/lang.json";
import getLangKeyValueFun from "../../../../utils/lang";
import { SEARCH_RESULT } from "../../utils";
const getText = getLangKeyValueFun(langGroup);
class WebSearch extends React.Component {
    constructor(props) {
        super(props);
        this.onInputKeywords = e => {
            this.setState({
                searchText: e.target.value
            }, () => {
                if (!this.state.searchText) {
                    this.setState({ searchResults: [] });
                    return;
                }
                else {
                    this.onSearchKeywords();
                    this.setState({
                        recentSearches: []
                    });
                }
            });
        };
        this.onSearchKeywords = () => {
            if (!!this.state.searchText) {
                getKeywordsAutocomplete({
                    method: "vela.keywords.autocomplete.get",
                    word: this.state.searchText,
                    num: 10
                }).then((res) => {
                    var _a;
                    this.setState({
                        searchResults: (_a = res === null || res === void 0 ? void 0 : res.info) === null || _a === void 0 ? void 0 : _a.keywords
                    });
                })
                    .catch(err => console.error(err));
            }
        };
        this.onStorageLocal = (e, keyword) => {
            e.stopPropagation();
            const { searchText } = this.state;
            const newSearchText = keyword || searchText;
            if (!!newSearchText) {
                let localStorageList = [];
                try {
                    localStorageList = JSON.parse(lsGetItem("RECENT_SEARCH_LIST")) || [];
                }
                catch (e) {
                    localStorageList = [];
                }
                if (!localStorageList.some(i => i === newSearchText)) {
                    localStorageList.unshift(newSearchText);
                    lsSetItem("RECENT_SEARCH_LIST", JSON.stringify(localStorageList));
                }
                this.onSearchPage(newSearchText);
            }
            else {
                this.setState({
                    isFlashing: true
                });
                setTimeout(() => {
                    this.setState({
                        isFlashing: false
                    });
                    this.onShowHideRecentSearch(e, true);
                }, 1000);
            }
        };
        this.onSearchPage = (keyword) => {
            location.href = `${SEARCH_RESULT()}${keyword}`;
        };
        this.onShowHideRecentSearch = (e, isShow) => {
            e.stopPropagation();
            if (!this.state.searchText) {
                this.setState({
                    recentSearches: isShow ? JSON.parse(lsGetItem("RECENT_SEARCH_LIST")) || [] : []
                });
            }
        };
        this.onClearLocalStorage = (e, index) => {
            e.stopPropagation();
            let localStorageList = [];
            try {
                localStorageList = JSON.parse(lsGetItem("RECENT_SEARCH_LIST")) || [];
            }
            catch (e) {
                localStorageList = [];
            }
            if (index >= 0) {
                localStorageList.splice(index, 1);
            }
            else {
                localStorageList = [];
            }
            lsSetItem("RECENT_SEARCH_LIST", JSON.stringify(localStorageList));
            this.setState({
                recentSearches: localStorageList
            });
        };
        this.onEnterPress = e => {
            if (e.keyCode === 13) {
                this.onStorageLocal(e);
            }
        };
        this.onClickNonSelectionArea = (e) => {
            e.stopPropagation();
        };
        this.state = {
            searchText: "",
            searchResults: [],
            recentSearches: [],
            isFlashing: false
        };
    }
    componentDidMount() {
        window.addEventListener("click", () => {
            this.setState({
                searchResults: [],
                recentSearches: []
            });
        });
    }
    render() {
        const { searchResults, recentSearches, isFlashing } = this.state;
        return (React.createElement(SearchContainer, null,
            React.createElement(SearchInput, { onClick: e => this.onShowHideRecentSearch(e, true), onChange: this.onInputKeywords, placeholder: "", className: isFlashing && "ani", onKeyDown: this.onEnterPress }),
            React.createElement(SearchIcon, { src: AssetImageUrl["ic_search@3x.png"], style: { width: "17px", height: "17px" }, alt: "Search" }),
            React.createElement(SearchButton, { onClick: e => this.onStorageLocal(e) }, getText("Search")),
            React.createElement(SearchResult, { onClick: this.onClickNonSelectionArea, className: (0 in searchResults || 0 in recentSearches) && "isShow" },
                React.createElement(SearchResultList, { className: 0 in recentSearches && "showSearches" },
                    0 in searchResults &&
                        (searchResults || []).map(item => (React.createElement(SearchResultItem, { key: item.position, onClick: e => this.onStorageLocal(e, item === null || item === void 0 ? void 0 : item.keyword) }, item === null || item === void 0 ? void 0 : item.keyword))),
                    0 in recentSearches && (React.createElement(React.Fragment, null,
                        React.createElement(RecentSearchesHeader, null,
                            React.createElement(RecentSearchesTitle, null, getText("Recent Searches")),
                            React.createElement(RecentSearchesClear, { onClick: e => this.onClearLocalStorage(e) }, getText("Clear All"))),
                        React.createElement(RecentSearchesList, null, recentSearches.map((item, index) => (React.createElement(RecentSearchesItem, { key: index, onClick: e => this.onStorageLocal(e, item) },
                            React.createElement("span", null, item),
                            React.createElement(RecentSearchesItemClear, { onClick: e => this.onClearLocalStorage(e, index) }, getText("Clear"))))))))))));
    }
}
export default WebSearch;
